// extracted by mini-css-extract-plugin
export default {"innerWrapper":"vA-z","tooltipWrapper":"wA-z","icon":"xA-z","tooltip":"yA-z","content":"zA-z"};